import React, { useEffect } from "react";
import "../moodle.css";
import { useStore } from "../../app/stores/store";

interface Props {
    llaves: any,
  
}

function Loginmoodle(props:Props) {

    const {userStore: {user, logout, isLoggedIn, roles,}} = useStore();

    function envia_form() {
      document.forms[0].submit();
      }

      useEffect(() => {
       
            envia_form()
       
          
    }, []);

     
        

    let usermoodle: any = user?.userName
    
    let llave: any = props.llaves
    return (
       

        <div >
          <div className="titulo2">
            <h1>Bienvenido</h1>
            <h1>Aula Virutal</h1>
          </div>

          {isLoggedIn ? (
            <>

            <div>
     
         <form action="https://aulavirtual.inap.gob.gt/login/index.php" method="post" id="login">
          <div className="fondo3">
          <div className= "login">
            <div className="titulos">
              <h3>Iniciar sesión</h3>
              <img src="images/loginap.png" alt="logo" />
            </div>
            </div>
          <div className="datos">
          <p className="ocultar">Usuario</p>
          <input name="username" id="username"  value={usermoodle} ></input>
         

         <p className="ocultar">Contraseña</p>

         <input  type="password" name="password" id="password"  value={llave} ></input>
         
    
         </div>
    
            <div className="boton">
              <button className="ocultar" type="submit">Ingresar</button>
            </div>
          </div>
    
          </form>

        </div>

          </>
                ) : (
                  <>

                  {/* <div>

<form action="http://168.194.73.85/moodle/login/index.php" method="post" id="login">
          <div className="fondo2">
          <div className= "login">
            <div className="titulos">
              <h3>Iniciar sesión</h3>
              <img src="images/loginap.png" alt="logo" />
            </div>
            </div>
          <div className="datos">
          <p>Usuario</p>
          <input name="username" id="username" ></input>
          <p>Contraseña</p>
          <input type="password" name="password" id="password" ></input>
    
         </div>
    
            <div className="boton">
              <button type="submit">Ingresar</button>
            </div>
          </div>
    
          </form>
          </div> */}

                      </>
                         )}

          
        </div>
      );
    }
    
    export default Loginmoodle;